import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { EidosIconType } from '../models/core-constant.model';
import { EidosConfigService } from '../services/eidos-config.service';
import { EidosUtilityService } from '../services/eidos-utility.service';
import { IEidosIcon } from '../services/environment.interface';
import { ErrorService } from './services/error.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {

  EidosIconType = EidosIconType;
  public logo?: IEidosIcon;
  public backgroundImage?: string;
  protected moduleName:string = '';

  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    protected coreConfigService: EidosConfigService,
    protected coreUtilityService: EidosUtilityService,
    private errorService: ErrorService
  ) {
    this.moduleName = "error";

    //Standard SVG Icons
    this.matIconRegistry.addSvgIcon(
      'logo_square_1c',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos_logo_square_1colore.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logo_square_2c',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos_logo_square_2colori.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logo_wide_1c',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos_logo_wide_1colore.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logo_wide_2c',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos_logo_wide_2colori.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logo_4.0_1c',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos4.0_logo_wide_1colore.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logo_4.0n_1c',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos4.0new_logo_wide_1colore.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'logo_4.0n_1c_v2',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/svg/eidos4.0new_logo_wide_1colore_v2.svg')
    );
  }

  ngOnInit(): void {
    this.coreConfigService.currentConfig.subscribe(config => {
      this.backgroundImage = config.errorBackground;
      this.logo = config.logo;
    });
  }
  /**
   * Go to return URL handler
   *
   * @memberof ErrorComponent
   */
  public goToReturnUrl(): void {
    window.location.href = this.errorService.returnUrl;
  }
}
